import axios from 'axios'
import { v4 as uuidv4 } from 'uuid'
import {
  getAuthorization,
  getNewTokens,
  updateLocalTokens
} from './refreshTokens'
import store from './vuex'

/* global PORTAL_URL */
/* global AUTH_TOKEN_KEY */

// Checks if a new token is set on URL and sets it on localStorage
var url = new URL(window.location.toString())

function _handleUrlParamTokens(tokenNameToHandle) {
  const token = url.searchParams.get(tokenNameToHandle)

  if (!!token) {
    localStorage.setItem(tokenNameToHandle, token)
    url.searchParams.delete(tokenNameToHandle)
    window.history.replaceState(null, document.title, url.toString())
  }
}

_handleUrlParamTokens(AUTH_TOKEN_KEY)
_handleUrlParamTokens('refresh_token')

// AXIOS NEW INSTANCE
export const ax = axios.create()

export function getToken() {
  return localStorage.getItem(AUTH_TOKEN_KEY)
}

export function logout() {
  localStorage.removeItem(AUTH_TOKEN_KEY)
  localStorage.removeItem(AUTH_REFRESH_TOKEN_KEY)

  window.location.href = PORTAL_URL + '/logout'
}

export function login() {
  window.location.href = PORTAL_URL + '/login'
}

// INTERCEPTORS REQUEST
ax.interceptors.request.use(
  (config) => {
    const token = getToken()

    if (token) {
      config.headers = Object.assign(config.headers, {
        Authorization: getAuthorization(token),
        'x-request-id': uuidv4()
      })
    }

    return config
  },
  (err) => {
    return Promise.reject(err)
  }
)

// INTERCEPTORS RESPONSE
ax.interceptors.response.use(
  (response) => {
    return response.data
  },
  async (err) => {
    const originalRequest = err.config

    if (
      axios.isAxiosError(err) &&
      err.response.status === 401 &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true

      try {
        const newTokens = await getNewTokens()
        updateLocalTokens(newTokens)
        originalRequest.headers.Authorization = getAuthorization(
          newTokens.access_token
        )

        return ax(originalRequest)
      } catch (_err) {
        logout()

        return Promise.reject(_err)
      }
    } else if (err.response.status === 403) {
      store.commit('show_warning_dialog')
    }

    return Promise.reject(err)
  }
)
